module.exports = "<span class=\"progressTimerStyle\">\r\n    {{ text }}\r\n</span>\r\n"